/**
 * Workflow Constants
 *
 * 워크플로우 모듈에서 사용되는 상수 정의
 */

// Node types
export const NODE_TYPES = {
  ALGORITHM: 'Algorithm',
  VISUALIZATION: 'Visualization'
};

// Node property keys
export const NODE_PROPERTIES = {
  CLASS: 'class',
  NAME: 'name'
};

// File format types
export const FILE_FORMATS = {
  NONE: 'none',
  SINGLE: 'single',
  MULTI: 'multi',
  ALGORITHM: 'algorithm'
};

// Default values
export const DEFAULT_VALUES = {
  TITLE: 'Untitled'
};

// State structure paths (for documentation)
export const STATE_PATHS = {
  WORKFLOW_DATA: 'workflow_info.drawflow.Home.data'
};
